import { Grid } from '@ui/core'
import type { GridProps } from '@ui/core'

export type { GridProps }
export default Grid
